(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

/*
    ga('create', {
        trackingId: 'UA-XXXXX-Y',
        cookieDomain: 'auto'
    });
    
    ga('send', {
        hitType: 'pageview'
    });
    
    ga('create', 'UA-XXXXX-Y', 'auto', 'myTracker');
    
    ga('create', 'UA-XXXXX-Y', 'auto', 'myTracker', {
        userId: '12345'
    });
    
    ga('create', {
        trackingId: 'UA-XXXXX-Y',
        cookieDomain: 'auto',
        name: 'myTracker',
        userId: '12345'
    });
    
    ga('clientTracker.send', 'pageview');
*/

class GoogleAnalytics
{
    // GA.create('UA-25251488-4', 'auto');
    static create(...args)
    {
        ga('create', ...args);
    }
    
    // GA.send('pageview');
    static send(...args)
    {
        ga('send', ...args);
    }
}

function init()
{
    ga('create', 'UA-25251488-4', 'auto');
    ga('send', 'pageview');
}

init();

export default ga;



// WEBPACK FOOTER //
// ./libs/vendor/google-analytics.js